// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  'data-role'?: string;
}

export default function RHFTextField(props: IProps & TextFieldProps) {
  const { name, required, ...other } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          data-role={props['data-role']}
          error={!!error}
          helperText={error?.message}
          {...other}
          required={required}
        />
      )}
    />
  );
}
